import * as React from 'react'

import { Box, type Colors, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import UserAvatar from 'modules/core/components/UserAvatar'
import { employeeUser } from 'modules/core/store/collections/users'

import type ContractFlow from 'modules/contracts/lib/ContractFlow'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
  flow: ContractFlow
  title: string
  background?: Colors
  onClose: () => void
}

const Header = ({ employee, flow, background, title, onClose }: Props) => {
  const onCloseClick = () => {
    flow.trackExit()
    onClose()
  }
  return (
    <Box
      width="full"
      height="s64"
      flexDirection="row"
      gap="s4"
      background={background || 'grey000White'}
      justifyContent="center"
      alignItems="center"
      border={{
        bottom: {
          width: 's2',
          color: 'grey300',
          style: 'solid',
        },
      }}
    >
      <UserAvatar user={employeeUser(employee)} size="s24" />
      <Text.Normal weight="semibold" size="300">
        {title}
      </Text.Normal>
      <Box
        width="s32"
        height="s32"
        justifyContent="center"
        alignItems="center"
        border={{
          all: {
            width: 's2',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs100',
        }}
        style={{ position: 'absolute', right: '18px' }}
      >
        <Touchable onClick={() => onCloseClick()}>
          <Icon.Medium icon="cross" />
        </Touchable>
      </Box>
    </Box>
  )
}

export default observer(Header)
